// extracted by mini-css-extract-plugin
module.exports = {"gallery":"Gallery_gallery__2ppiE","header":"Gallery_header__3stGR","pagination":"Gallery_pagination__1CLYN","name":"Gallery_name__27ODY","img":"Gallery_img__2tmXD"};